// import React, { useState, useEffect, useRef } from "react";
// import axiosInstance from "../../../../axios";
// import { Loading } from "../../../Other/Loading";
// import axios from "axios";

// const ReplyModal = ({
//   revulsionModalStatus,
//   setRevulsionModalStatus,
//   getByIdRepliesCollectionHandler,
//   fetchUserForumPosts,
//   studentPurchasedCourseDetails,
//   setNestedRepliesCollection,
//   forumAskQueryActionHandler,
//   userAskQuestionsModalPopup,
//   forumId,
//   setForumId,
//   cId,
// }) => {
//   const { REACT_APP_LOGIN_API_BASEURL } = process.env;

//   const InitialValue = {
//     courseId: "",
//     title: "",
//     description: "",
//     mediaLink: "",
//   };

//   const fileInputRef = useRef();
//   const [forumCreateDetails, setForumCreateDetails] = useState(InitialValue);
//   const [fileNameSet, setfileNameSet] = useState("");
//   const [uploadStatus, setUploadStatus] = useState("");
//   const [postResponseStatus, setPostResponseStatus] = useState({
//     postStatus: false,
//     postResponseMessage: "",
//   });
//   const [errorMsg, setErrorMsg] = useState("");
//   const [error, setError] = useState(false);
//   const [isloading, setIsLoading] = useState(false);

//   useEffect(() => {
//     if (revulsionModalStatus?.isEdit) {
//       const { forumsCourseId, forumsDescription, forumsTitle } = revulsionModalStatus;
//       setForumCreateDetails({
//         ...forumCreateDetails,
//         courseId: forumsCourseId,
//         description: forumsDescription,
//         title: forumsTitle,
//       });
//     } else {
//       setForumCreateDetails({
//         ...forumCreateDetails,
//         courseId: revulsionModalStatus?.threadId,
//         title: revulsionModalStatus?.forumsTitle,
//       });
//     }
//   }, [revulsionModalStatus]);

//   const forumHandleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "courseId") {
//       const selectedOption = e.target.selectedOptions[0];
//       setForumCreateDetails((prev) => ({
//         ...prev,
//         courseId: value,
//         title: selectedOption.text,
//       }));
//     } else {
//       setForumCreateDetails((prev) => ({
//         ...prev,
//         [name]: value,
//       }));
//     }
//   };

//   const handleFileUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const courseId = forumCreateDetails.courseId || cId;
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("courseId", courseId);

//     try {
//       setUploadStatus("Uploading...");
//       const res = await axiosInstance.post(
//         `${REACT_APP_LOGIN_API_BASEURL}/image`,
//         formData,
//         {
//           headers: { "Content-Type": "multipart/form-data" },
//         }
//       );
//       console.log("res--",res)

//       setfileNameSet(res?.data?.url);
//       setUploadStatus( res?.data?.message || "Upload Successful ?");

//       setForumCreateDetails((prev) => ({
//         ...prev,
//         mediaLink: res?.data?.url,
//       }));
//     } catch (err) {
//       console.error("Upload failed", err);
//       setUploadStatus("Upload Failed ?");
//     }
//   };

//   const formumSubmitHandler = () => {
//     setIsLoading(true);
//     const { title, description, mediaLink } = forumCreateDetails;
//     console.log("forumCreateDetails-", forumCreateDetails)
//     if (!title || !description || !fileNameSet) {
//       setErrorMsg("*Please fill all the fields.");
//       setIsLoading(false);
//       return;
//     }

//     const endpoint = revulsionModalStatus?.isEdit
//       ? `${REACT_APP_LOGIN_API_BASEURL}/forum/${revulsionModalStatus?.currentForumsIndexId}`
//       : `${REACT_APP_LOGIN_API_BASEURL}/forum`;

//     const method = revulsionModalStatus?.isEdit ? "put" : "post";

//     axiosInstance[method](endpoint, forumCreateDetails)
//       .then((res) => {
//         if (res?.data?.message) {
//           setPostResponseStatus({
//             postStatus: true,
//             postResponseMessage: res.data.message,
//           });

//           setForumCreateDetails(InitialValue);
//           fetchUserForumPosts();

//           if (revulsionModalStatus?.currentState === "levelOne") {
//             getByIdRepliesCollectionHandler(revulsionModalStatus.previousPostId);
//           } else if (revulsionModalStatus?.currentState === "levelTwo") {
//             setNestedRepliesCollection(revulsionModalStatus.previousPostId);
//           }
//         }
//         if (res?.data?.error) setError(true);
//         setIsLoading(false);
//       })
//       .catch((err) => {
//         setIsLoading(false);
//       });
//   };

//   return (
//     <div className="max-w-xl w-full mx-auto bg-white rounded-2xl shadow-xl p-8">
//       {postResponseStatus.postStatus ? (
//         <div className="flex flex-col items-center justify-center py-8">
//           <button
//             className="!absolute top-4 right-4 text-gray-400 hover:text-gray-600"
//             onClick={() =>
//               userAskQuestionsModalPopup
//                 ? forumAskQueryActionHandler()
//                 : setRevulsionModalStatus({ ...revulsionModalStatus, conceal: false })
//             }
//           >
//             ?
//           </button>
//           <img
//             src={
//               error
//                 ? `${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-failure-check.svg`
//                 : `${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`
//             }
//             className="w-16 h-16 mb-4"
//             alt="status"
//           />
//           <p className="text-lg font-semibold text-gray-700 text-center">
//             {postResponseStatus.postResponseMessage}
//           </p>
//         </div>
//       ) : (
//         <form className="space-y-5">
//           {userAskQuestionsModalPopup && (
//             <select
//               name="courseId"
//               value={forumCreateDetails.courseId}
//               onChange={forumHandleChange}
//               className="w-full border px-4 py-2 rounded"
//             >
//               <option value="">Select course</option>
//               {studentPurchasedCourseDetails?.map((course) => (
//                 <option key={course.ID} value={course.ID}>
//                   {course.CourseName}
//                 </option>
//               ))}
//             </select>
//           )}

//           <textarea
//             name="description"
//             rows={4}
//             value={forumCreateDetails.description}
//             onChange={forumHandleChange}
//             placeholder="Write your question here..."
//             className="w-full border px-4 py-2 rounded resize-none"
//           />

//           <div>
//             <label className="block mb-1">Upload File</label>
//             <div className="flex gap-2 items-center">
//               <input
//                 type="text"
//                 value={fileNameSet}
//                 placeholder="No file selected"
//                 readOnly
//                 className="flex-1 px-3 py-2 border rounded"
//               />
//               <input
//                 type="file"
//                 className="hidden"
//                 id="file-upload"
//                 ref={fileInputRef}
//                 onChange={handleFileUpload}
//               />
//               <label
//                 htmlFor="file-upload"
//                 className="px-4 py-2 bg-blue-600 text-white rounded cursor-pointer"
//               >
//                 Upload
//               </label>
//             </div>
//             <p className="text-sm text-gray-500">{uploadStatus}</p>
//           </div>

//           {errorMsg && <p className="text-red-500 text-sm">{errorMsg}</p>}

//           <div className="flex justify-end gap-3 pt-2">
//             <button
//               type="button"
//               className="bg-gray-200 px-5 py-2 rounded"
//               onClick={() =>
//                 userAskQuestionsModalPopup
//                   ? forumAskQueryActionHandler()
//                   : setRevulsionModalStatus({ ...revulsionModalStatus, conceal: false })
//               }
//             >
//               Cancel
//             </button>
//             <button
//               type="button"
//               className={`px-6 py-2 text-white rounded ${forumCreateDetails.title && forumCreateDetails.description && fileNameSet
//                   ? "bg-blue-600 hover:bg-blue-700"
//                   : "bg-blue-200 cursor-not-allowed"
//                 }`}
//               disabled={
//                 !forumCreateDetails.title ||
//                 !forumCreateDetails.description ||
//                 !fileNameSet
//               }
//               onClick={formumSubmitHandler}
//             >
//               {isloading ? <Loading /> : "Submit"}
//             </button>
//           </div>
//         </form>
//       )}
//     </div>
//   );
// };

// export default ReplyModal;




import React, { useState, useEffect, useRef } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { toBinary } from "../../../../_helpers";
import axios from "axios";

const ReplyModal = ({
  revulsionModalStatus,
  setRevulsionModalStatus,
  getByIdRepliesCollectionHandler,
  fetchUserForumPosts,
  studentPurchasedCourseDetails,
  setNestedRepliesCollection,
  forumAskQueryActionHandler,
  userAskQuestionsModalPopup,
  forumId,
  setForumId,
  cId,
}) => {
  const { REACT_APP_LOGIN_API_BASEURL } = process.env;
  const InitialValue = {
    courseId: "",
    title: "",
    description: "",
    mediaLink: "",
  };



  const fileInputRef = useRef();

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [fileNameSet, setfileNameSet] = useState("");

  const [forumCreateDetails, setForumCreateDetails] = useState(InitialValue);
  const [postResponseStatus, setPostResponseStatus] = useState({
    postStatus: false,
    postResponseMessage: "",
  });
  const [isloading, setIsLoading] = useState(false);

  const formumSubmitHandler = async () => {
    setIsLoading(true);

    if (!forumCreateDetails.title || !forumCreateDetails.description) {
      setErrorMsg("*Please fill all the fields.");
      setIsLoading(false);
      return;
    }

    try {
      let res;

      if (revulsionModalStatus?.isEdit) {
        res = await axiosInstance.put(
          `${REACT_APP_LOGIN_API_BASEURL}/forum/${revulsionModalStatus?.currentForumsIndexId}`,
          forumCreateDetails
        );
      } else {
        res = await axiosInstance.post(
          `${REACT_APP_LOGIN_API_BASEURL}/forum`,
          forumCreateDetails
        );
      }

      if (res?.data?.message) {
        setPostResponseStatus({
          ...postResponseStatus,
          postStatus: true,
          postResponseMessage: res.data.message,
        });

        setForumCreateDetails({
          courseId: "",
          title: "",
          description: "",
          mediaLink: "",
        });

        if (revulsionModalStatus?.isEdit) {
          fetchUserForumPosts();
          if (revulsionModalStatus?.currentState === "levelOne") {
            getByIdRepliesCollectionHandler(revulsionModalStatus.previousPostId);
          } else if (revulsionModalStatus?.currentState === "levelTwo") {
            setNestedRepliesCollection(revulsionModalStatus.previousPostId);
          }
        } else {
          if (revulsionModalStatus?.currentState === "levelOne") {
            getByIdRepliesCollectionHandler(revulsionModalStatus?.previousPostId);
          } else if (revulsionModalStatus?.currentState === "levelZero") {
            fetchUserForumPosts();
            getByIdRepliesCollectionHandler(revulsionModalStatus?.threadId);
          }
          fetchUserForumPosts();
        }
      }

      if (res?.data?.error === true) {
        setError(true);
      }

    } catch (error) {
      console.error("Forum submission error:", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (revulsionModalStatus?.isEdit) {
      const { forumsCourseId, forumsDescription, forumsTitle } =
        revulsionModalStatus;
      forumCreateDetails["threadId"] = forumCreateDetails["courseId"];
      delete forumCreateDetails["courseId"];
      setForumCreateDetails({
        ...forumCreateDetails,
        threadId: forumsCourseId,
        description: forumsDescription,
        title: forumsTitle,
      });
    } else if (!revulsionModalStatus?.isEdit) {
      forumCreateDetails["threadId"] = forumCreateDetails["courseId"];
      delete forumCreateDetails["courseId"];
      setForumCreateDetails({
        ...forumCreateDetails,
        threadId: revulsionModalStatus?.threadId,
        title: revulsionModalStatus?.forumsTitle,
      });
    }
  }, [revulsionModalStatus]);

  const forumHandleChange = (e) => {
    if (e.target.name === "courseId") {
      var selectedOption = e.target.selectedOptions[0];
      setForumCreateDetails({
        ...forumCreateDetails,
        title: selectedOption.text,
        courseId: e.target.value,
      });
    } else {
      setForumCreateDetails({
        ...forumCreateDetails,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setfileNameSet(file.name);
    setIsLoading(true);

    try {
      const res = await axiosInstance.post(
        `${REACT_APP_LOGIN_API_BASEURL}/image`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      console.log("res--", res);
      const uploadedUrl = res?.data?.url;
      setfileNameSet(uploadedUrl);
      setForumCreateDetails((prev) => ({
        ...prev,
        mediaLink: uploadedUrl,
      }));
    } catch (err) {
      console.error("Upload failed", err);
      setErrorMsg("Upload failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <>
      <div
        className={
          !userAskQuestionsModalPopup
            ? "w-full mx-auto bg-white rounded-2xl shadow-xl p-8"
            : "max-w-xl w-full mx-auto bg-white rounded-2xl shadow-xl p-8"
        }
      >
        {postResponseStatus.postStatus && (
          <div>
            <div className="flex flex-col justify-end items-end ">
              <button
                className="text-gray-400 hover:text-gray-600"
                onClick={() =>
                  userAskQuestionsModalPopup
                    ? forumAskQueryActionHandler()
                    : setRevulsionModalStatus({
                      ...revulsionModalStatus,
                      conceal: false,
                    })
                }
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="flex flex-col items-center justify-center py-8">

              <img
                className="w-16 h-16 mb-4"
                src={
                  error
                    ? `${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-failure-check.svg`
                    : `${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`
                }
                alt="check-complete"
              />
              <p className="text-lg font-semibold text-gray-700 text-center">{postResponseStatus.postResponseMessage}</p>
            </div>
          </div>
        )}

        {!postResponseStatus.postStatus && (
          <>
            <div className="mb-6">
              {!userAskQuestionsModalPopup && (
                <p className="text-lg font-semibold text-gray-700 mb-2">
                  Replying For <span className="text-blue-600">{forumCreateDetails.title}</span>
                </p>
              )}
              {userAskQuestionsModalPopup && (
                <p className="text-lg font-semibold text-gray-700 mb-2">Add Your Question</p>
              )}
            </div>

            <div>
              <div className="bg-gray-50 rounded-xl p-6 mb-4">
                <form className="space-y-5">
                  {userAskQuestionsModalPopup && studentPurchasedCourseDetails && (
                    <select
                      id="select-course-tab"
                      name="courseId"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
                      value={forumCreateDetails.courseId}
                      onChange={forumHandleChange}
                    >
                      <option value="" disabled>
                        Select course
                      </option>
                      {studentPurchasedCourseDetails &&
                        studentPurchasedCourseDetails.length > 0 &&
                        studentPurchasedCourseDetails.map((items) => (
                          <option
                            value={items.ID}
                            key={items.ID}
                          >
                            {items.CourseName}
                          </option>
                        ))}
                    </select>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Description
                    </label>
                    <textarea
                      className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200 resize-none"
                      name="description"
                      rows={4}
                      value={forumCreateDetails.description}
                      onChange={forumHandleChange}
                      placeholder="Type your message here..."
                    ></textarea>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Upload File or Enter URL
                    </label>
                    <div className="flex gap-2">
                      <input
                        className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
                        name="mediaLink"
                        value={fileNameSet}
                        placeholder="Enter url here..."
                        readOnly
                      />
                      <input
                        className="hidden"
                        name="mediaLink"
                        type="file"
                        id="file-upload"
                        ref={fileInputRef}
                        onChange={handleFileUpload}
                      />
                      <label
                        htmlFor="file-upload"
                        className="inline-block bg-blue-50 text-blue-700 px-4 py-2 rounded-lg cursor-pointer border border-blue-200 hover:bg-blue-100 transition"
                      // onClick={handleCreateForum}
                      >
                        Upload
                      </label>
                    </div>
                  </div>
                  {errorMsg && <p className="text-red-500 text-xs">{errorMsg}</p>}

                  {!isloading && (
                    <div className="flex justify-end gap-3 pt-2">
                      <button
                        type="button"
                        className="bg-gray-100 text-gray-700 px-5 py-2 rounded-lg hover:bg-gray-200 transition"
                        onClick={() =>
                          userAskQuestionsModalPopup
                            ? forumAskQueryActionHandler()
                            : setRevulsionModalStatus({
                              ...revulsionModalStatus,
                              conceal: false,
                            })
                        }
                      >
                        Cancel
                      </button>
                      {forumCreateDetails.title !== "" &&
                        forumCreateDetails.description !== "" &&
                        fileNameSet !== "" ? (
                        <button
                          type="button"
                          className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-700 transition"
                          onClick={() => formumSubmitHandler()}
                        >
                          Submit
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="bg-blue-200 text-white px-6 py-2 rounded-lg shadow cursor-not-allowed"
                          disabled
                        >
                          Submit
                        </button>
                      )}
                    </div>
                  )}

                  {isloading && (
                    <div className="flex justify-center py-4">
                      <Loading />
                    </div>
                  )}
                </form>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ReplyModal;
